// src/components/ErrorBoundary.js
import React, { Component } from 'react';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    // This lifecycle method is called if an error is thrown by a child component
    static getDerivedStateFromError(error) {
        // Update state so the next render shows the fallback UI.
        return { hasError: true };
    }

    // This lifecycle method is called after an error has been thrown
    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service here
        console.error("Uncaught error:", error, errorInfo);

        // In a real production app, you might send this to Sentry, Rollbar, etc.
        // Example (pseudo-code):
        // if (process.env.NODE_ENV === 'production') {
        //   logErrorToService(error, errorInfo);
        // }

        this.setState({
            error: error,
            errorInfo: errorInfo
        });
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <div style={{ padding: '20px', border: '1px solid red', borderRadius: '5px' }}>
                    <h2>Oops! Kaut kas nogāja greizi.</h2>
                    <p>Atvainojamies par neērtībām! Ja šis atkārtojas, lūdzu, sazinieties ar mums.</p>
                    {process.env.NODE_ENV === 'development' && this.state.error && (
                        <details style={{ whiteSpace: 'pre-wrap' }}>
                            {this.state.error.toString()}
                            <br />
                            {this.state.errorInfo.componentStack}
                        </details>
                    )}
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
